import { store } from "@/store";
import axios from "axios";
import { DateTime as TimeFormatter } from "luxon";
import moment from "moment";

export const syncStore = {
  namespaced: true,
  state: () => ({
    allUnsyncedRecords: "",
    allSyncedRecords: "",
    syncedRecords: "",
    token: "",
    UnsyncedRecords: { status: false, records: "" },
    lastSyncedTime: {
      type: "last_synced_time",
      _id: new Date().toISOString(),
      time: new Date().toISOString()
    },
    isSyncing: false
  }),
  getters: {
    getAllUnsyncedRecords: () => {
      return store.getters.allRecords.filter(record => {
        return !record.is_synced;
      });
    }
  },
  mutations: {
    getUnsyncedRecords(state) {
      store.state.database
        .find({
          selector: {
            is_synced: false
          }
        })
        .then(result => {
          state.allUnsyncedRecords = result.docs;
        })
        .catch(function(err) {
          console.log(err.responses);
        });
    },

    getAllSyncedRecordsFromServer(state) {
      axios
        .get("logbook/all", {
          headers: { Authorization: "Bearer " + store.state.auth.token }
        })
        .then(res => {
          state.syncedRecords = res.data;
          store.commit("sync/convertPropertiesBeforeSavingFromServer");
          store.commit("sync/updateAllLocalRecords");
          store.commit("sync/getUnsyncedRecords");
          store.commit("sync/saveLastSyncedTime", new Date().toISOString());
          store.commit("sync/getLastSyncedTime");
        })
        .catch(err => {
          console.log(err);
        });
    },

    syncAllUnsyncedRecords(state) {
      if (state.allUnsyncedRecords.length > 0) {
        state.isSyncing = true;
        const uninterceptedAxiosInstance = axios.create();
        uninterceptedAxiosInstance
          .post(
            "logbook/sync",
            {
              data: state.allUnsyncedRecords
            },
            { headers: { Authorization: "Bearer " + state.token } }
          )
          .then(() => {
            store.commit("sync/getRecentRecords");
            state.allUnsyncedRecords = [];
            // state.syncedRecords = res.data;
            // store.commit("sync/getUnsyncedRecords");
            state.isSyncing = false;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    updateAllLocalRecords(state) {
      for (let item of state.syncedRecords) {
        // console.log(item);
        store.state.database.put(item, { force: true }, function callback(err) {
          if (err) {
            console.log(err);
            return false;
          }
        });
      }

      store.commit("sync/reloadAllLocalRecords");
    },
    convertPropertiesBeforeSavingFromServer(state) {
      for (let i = 0; state.syncedRecords.length > i; i++) {
        state.syncedRecords[i]["_id"] = state.syncedRecords[i].pouch_id; //rename pouch id

        //convert saved_at time format to ISO string
        if (state.syncedRecords[i].saved_at) {
          TimeFormatter.fromISO(
            new Date(state.syncedRecords[i].saved_at).toISOString()
          ).toFormat("ff");
        }

        //convert car purchase_at time stamp if exists
        if (state.syncedRecords[i].type === "vehicle") {
          TimeFormatter.fromISO(
            new Date(state.syncedRecords[i].purchase_date).toISOString()
          ).toFormat("ff");
        }
        state.syncedRecords[i].trip_time &&
        state.syncedRecords[i].type === "trip"
          ? (state.syncedRecords[i].trip_time = TimeFormatter.fromISO(
              new Date(state.syncedRecords[i].trip_time).toISOString()
            ).toFormat("ff"))
          : "";
        delete state.syncedRecords[i].user_id;
        delete state.syncedRecords[i].pouch_id;
      }
    },
    reloadAllLocalRecords() {
      store.dispatch("place/getPlacesAction");
      store.commit("trip/getAllTrips");
      store.commit("expense/getAllExpenses");
      // store.commit("stat/getAlltrips");
      store.commit("car/getCars");
    },
    getRecentRecords(state) {
      state.isSyncing = true;
      let time = moment(state.lastSyncedTime.time)
        .subtract("1", "hour")
        .toISOString();
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get("logbook/recently_synced?time=" + time, {
          headers: { Authorization: "Bearer " + store.state.auth.token }
        })
        .then(res => {
          state.syncedRecords = res.data;
          store.commit("sync/saveLastSyncedTime", new Date().toISOString());
          store.commit("sync/convertPropertiesBeforeSavingFromServer");
          store.commit("sync/updateAllLocalRecords");
          // store.commit("getAllRecord");
          state.isSyncing = false;
          store.commit("sync/getLastSyncedTime");
        })
        .catch(err => {
          console.log(err);
        });
    },
    getLastSyncedTime(state) {
      state.lastSyncedTime = localStorage.getItem("last_synced_time")
        ? JSON.parse(localStorage.getItem("last_synced_time"))
        : {
            type: "last_synced_time",
            _id: new Date().toISOString(),
            time: new Date().toISOString()
          };
    },
    saveLastSyncedTime(state, time) {
      localStorage.setItem(
        "last_synced_time",
        JSON.stringify(state.lastSyncedTime)
      );
      state.lastSyncedTime.time = time;
      // store.commit("saveR", state.lastSyncedTime);
    }
  },
  actions: {
    syncAllDataAction({ commit }) {
      commit("syncAllUnsyncedRecords");
    }
  }
};
